import mapboxgl from 'mapbox-gl';
import polyline from '@mapbox/polyline'
import { featureCollection, feature } from '@turf/helpers';
import length from '@turf/length';
import lineSliceAlong from '@turf/line-slice-along';
import along from '@turf/along';
import buffer from '@turf/buffer';
import { jsonFetch } from '../droom/utilities';

import routes from './routes.json'

mapboxgl.accessToken = 'pk.eyJ1Ijoic3Bhbm5lciIsImEiOiJjOTAzMjBhZjhkMDg4NjdkMzVmMDY0NGRkNTcyZmY3NCJ9.0XFBMmFjoaBHoJwNHsqjwA'

const povs = {
  // "Paternoster Square": {
  //   center: [-0.097978, 51.513644],
  //   zoom: 17.0,
  //   bearing: 110.0,
  //   pitch: 60.0,
  // },
  // "Bloomberg Arcade": {
  //   center: [-0.092187, 51.512618],
  //   zoom: 17.0,
  //   bearing: -60,
  //   pitch: 60.0,
  // },
  outward: {
    center: [-0.09239969374357315, 51.5133893463433],
    pitch: 75,
    bearing: -86,
    zoom: 16.75,
  },
  return: {
    center: [-0.10629053272919009, 51.51133847056724],
    pitch: 60,
    bearing: 70,
    zoom: 17,
  },
  default: {
    center: [-0.10056334077989959, 51.512381872203065],
    pitch: 40,
    bearing: -100,
    zoom: 14,
  }
};

class TlmsMap {
  constructor(el) {
    this._el = el;
    this._legend = document.getElementById('mapcaption');
    this._clock = document.getElementById('clock');
    this._info = this._legend.querySelector('.info');
    this._serials = [];
    this._logging = true;
    this._procession = this._el.dataset.procession;
    this._serial_cache = {};
    this._map = new mapboxgl.Map({
      container: this._el,
      center: [-0.10056334077989959, 51.512381872203065],
      pitch: 0,
      bearing: 0,
      zoom: 13,
      antialias: true,
    });
    this._map.on('load', this.initMap.bind(this));
    // this._map.on('styledata', this.resizeMap.bind(this));
    this._offset = 0;
    this._speedup = 1;
    this._demoing = false;

    const povSetters = this._legend.querySelectorAll('a[data-pov]');
    povSetters.forEach((el) => {
      el.addEventListener('click', this.clickPov.bind(this));
    })
    const closer = this._legend.querySelector('a.close');
    if (closer) {
      closer.addEventListener('click', this.closeInfo.bind(this));
    }
    const demo = this._legend.querySelector('a.demo');
    if (demo) {
      demo.addEventListener('click', this.toggleDemo.bind(this));
    }
    window.mp = this;
  }

  resizeMap() {
    this._map.resize();
  }

  startDemo() {
    const route = this._routes[0]
    if (route) {
      const now = new Date().getTime()
      route.startDate ||= Date.parse(route.start);
      this._offset = route.startDate + 6000 - now;
      this._speedup = 4;
      this._demoing = true;
      this.setPov('outward');
    }
  }

  stopDemo() {
    this._offset = 0;
    this._speedup = 1;
    this._demoing = false;
  }

  clickPov(e) {
    const pov = e.target && e.target.dataset.pov;
    if (pov) {
      this.setPov(pov);
    }
  }

  setPov(key, bounds) {
    const pov = povs[key];
    if (pov) {
      this._map.flyTo(pov);
    } else if (bounds) {
      this._map.fitBounds(bounds, {padding: 50});
    } else {
      this._map.flyTo(povs.default);
    }
    this.closeInfo();
  }

  toggleDemo(e) {
    const a = e.target;
    e.preventDefault()
    if (this._offset === 0) {
      this.startDemo();
      a.innerText = "Stop demo";
    } else {
      this.stopDemo();
      a.innerText = "Start demo";
    }
  }

  // external link to named feature if any
  gotoFeature(feature_type, feature_name) {
    // const route = _.find(this._features.routes.features, (r) => r.properties.name === feature_name);
    // if (route) {
    //   coords = route.geometry.coordinates[0];
    //   bounds = coords.reduce((bounds, coord) => { bounds.extend(coord) }, new mapboxgl.LngLatBounds(coords[0], coords[0]));
    //   this.setPov(feature_name);
    //   // TODO: populate sheet
    //   this.featurePopupAfterMove(route);
    // }
    // else if serial
    // or poi
  }

  // resetView() {
  //   this._map.flyTo(povs.default);
  //   if (this._popup) this._popup.remove();
  // }

  // serialCaption(e, feature) {
  //   if (e) {
  //     e.preventDefault();
  //     if (!feature) feature = e.features[0];
  //   }
  //   this.log("serialCaption", e, feature);
  // }

  initMap() {
    this.log("💡 initMap");
    // this._map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
    // this._map.addControl(new mapboxgl.FullscreenControl(), 'bottom-right');
    // this._map.addControl(new mapboxgl.GeolocateControl(), 'bottom-right');

    // this._map.setConfigProperty('basemap', 'lightPreset', 'dusk');
    this._map.setConfigProperty('basemap', 'showPointOfInterestLabels', true);

    // this.addBuildings();
    this.initFog();
    this.initLayers();
    this.showRoutes();
    this.fetchSerials();

    // this.addPois(pois);
    // this.startDemo();

    this.setPov('default');
    // this._map.on('click', this.findFeatureAction.bind(this));
    this._map.on('styleimagemissing', this.getMissingImage.bind(this));
    this.resizeMap();
  }

  initFog() {
    this._map.setFog({
      'range': [0.5, 10],
      'horizon-blend': 0.3,
      'color': 'white',
      'high-color': '#add8e6',
      'space-color': '#d8f2ff',
      'star-intensity': 0.0
    });
  }

  initLayers() {
    if (!this._map.getSource('routes-source')) {
      this._map.addSource('routes-source', {
        type: "geojson",
        data: featureCollection([]),
      });
    }
    if (!this._map.getSource('serials-source')) {
      this._map.addSource('serials-source', {
        type: "geojson",
        data: featureCollection([]),
      });
    }
    if (!this._map.getSource('serials-midpoint-source')) {
      this._map.addSource('serials-midpoint-source', {
        type: "geojson",
        data: featureCollection([]),
      });
    }

    this._map.addLayer({
      id: 'routes',
      type: 'line',
      source: 'routes-source',
      slot: 'middle',
      paint: {
        'line-color': ['get', 'color'],
        'line-opacity': 0.4,
        'line-width': ["interpolate", ["linear"], ["zoom"], 12, 0, 19, 32],
      }
    });
    this._map.addLayer({
      id: 'route-arrows',
      type: 'symbol',
      source: 'routes-source',
      slot: 'middle',
      layout: {
        'symbol-placement': 'line',
        'symbol-spacing': 150,
        'icon-allow-overlap': true,
        'icon-image': 'arrow',
        'icon-size': ["interpolate", ["linear"], ["zoom"], 12, 0.01, 19, 0.25],
        'visibility': 'visible',
      }
    });

    this._map.addLayer({
      id: 'serials',
      type: 'fill',
      source: 'serials-source',
      slot: 'middle',
      minZoom: 12,
      paint: {
        'fill-color': ['get', 'color'],
        'fill-opacity': ["interpolate", ["linear"], ["zoom"], 12, 0, 15.5, 0.9],
      }
    });

    this._map.addLayer({
      id: 'serials-solid',
      type: 'fill-extrusion',
      source: 'serials-source',
      slot: 'middle',
      minZoom: 15,
      paint: {
        'fill-extrusion-color': ['get', 'color'],
        'fill-extrusion-height': 5,
        'fill-extrusion-base': 0,
        'fill-extrusion-opacity': ["interpolate", ["linear"], ["zoom"], 15, 0, 15.5, 0.9],
        'fill-extrusion-vertical-gradient': true,
      }
    });

    const label_filter = [
      'case',
      // Always show the symbol when pitch <= 45
      ['<=', ['pitch'], 45],
      true,
      // When pitch > 45, show the symbol only when it is close to the camera
      ['all', ['<=', ['distance-from-center'], 0.75], ['>', ['pitch'], 45]],
      true,
      // Hide in the remaining case, far and high pitch
      false
    ]

    this._map.addLayer({
      id: 'serial-masts',
      type: 'symbol',
      source: "serials-midpoint-source",
      filter: label_filter,
      slot: 'top',
      minZoom: 15,
      layout: {
        "icon-image": "bar",
        "icon-size": ["interpolate", [ "linear" ], [ "zoom" ], 15, 0.05, 19, 1.5],
        "icon-anchor": "bottom",
        "icon-allow-overlap": true,
        "icon-keep-upright": true,
        'icon-offset': [0, -7],
        "icon-pitch-alignment": "viewport",
      },
      paint: {
        "icon-opacity": ["interpolate", ["linear"], ["zoom"], 15, 0, 16, 1, 18.5, 1, 19, 0]
      }
    });

    this._map.addLayer({
      id: 'serial-labels',
      type: 'symbol',
      source: 'serials-midpoint-source',
      filter: label_filter,
      slot: 'top',
      minZoom: 15,
      layout: {
        "text-anchor": "bottom-left",
        "text-field": [
          "format",
          ["get", "prefix"], { "font-scale": 1.15, "text-transform": "uppercase" },
          "\n", {},
          ["get", "title"], { "font-scale": 0.75 },
        ],
        "text-font": [
          "DIN Offc Pro Medium",
          "Arial Unicode MS Bold"
        ],
        "text-size": ["interpolate", [ "linear" ], [ "zoom" ], 15, 1, 19, 40],
        "text-pitch-alignment": "viewport",
        "text-allow-overlap": true,
        "text-line-height": 1.15,
        "text-justify": "left",
        "text-max-width": 20,
        "text-offset": [0.2, -2],
        "text-keep-upright": true
      },
      "paint": {
        "text-color": "white",
        "text-halo-color": "rgba(0,0,0,0.25)",
        "text-halo-width": 1,
        "text-halo-blur": 2,
        "text-opacity": ["interpolate", ["linear"], ["zoom"], 15, 0, 16, 1, 18.5, 1, 19, 0]
      }
    });
  }

  update() {
    window.requestAnimationFrame(this.updateSerials.bind(this));
  }

  showRoutes() {
    // static shortcut
    const data = routes;
    const routesSource = this._map.getSource('routes-source')
    if (routesSource) {
      this._routes = data;
      const route_features = data.map((r) => {
        const path = r.paths[0];
        if (path) {
          r.linestring = polyline.toGeoJSON(path);
          r.length = length(r.linestring);
          return feature(r.linestring, {
            type: "route",
            uid: r.uid,
            title: r.title,
            description: r.description,
            color: `rgba(${r.color.r}, ${r.color.g}, ${r.color.b}, ${r.color.alpha})`,
            width: 32,
          })
        }
      });

      const routes_feature_collection = featureCollection(route_features);
      routesSource.setData(routes_feature_collection);
    }
  }

  fetchSerials() {
    if (this._procession) {
      const serials_url = `/api/processions/${this._procession}/serials`;
      this.log("serials_url", serials_url);
      jsonFetch(serials_url).then(this.receiveSerials.bind(this));
    }
  }

  receiveSerials(jsonData) {
    this._serials = jsonData.data.map((datum) => {
      return Object.assign(datum.attributes, { type: "serial" });
    });
    this.updateSerialShapes();
    this.fetchOffset();
    window.setInterval(this.updateSerialShapes.bind(this), 200);
    window.setInterval(this.fetchOffset.bind(this), 10000);
  }

  updateSerialShapes() {
    const now = new Date().getTime() + this._offset;
    const route = this._routes.find((r) => {
      r.startDate ||= Date.parse(r.start);
      r.endDate ||= Date.parse(r.end);
      return r.startDate <= now && now <= r.endDate;
    });
    if (route && route !== this._active_route) {
      this._active_route = route;
      this.setPov(route.key);
    }
    const shapes = [];
    const midpoints = [];
    if (route) {
      const elapsed_time = now - route.startDate;                          // milliseconds elapsed
      const head_distance = elapsed_time * 3.96 * this._speedup / 1000;    // feet per second
      this._serials.forEach((serial) => {
        const line_segment = lineSegmentForSerialOnRoute(serial, route, head_distance);
        if (line_segment) {
          const midpoint = along(line_segment, length(line_segment) / 2).geometry;
          const shape = buffer(line_segment, 0.005).geometry;
          const color = serial.colors[0] || '8d9a9c'
          const title = serial.title.length > 32 ? serial.title.substring(0, 30) + '...' : serial.title;
          const properties = {
            type: 'serial',
            uid: serial.uid,
            prefix: `${serial.position}${serial.suffix || ''}`,
            title: title,
            image_url: serial.image_url,
            description: serial.description,
            color: `#${color}`
          };
          shapes.push(feature(shape, properties));
          midpoints.push(feature(midpoint, properties));
        }
      });
    }

    const shapeCollection = featureCollection(shapes)
    this._map.getSource('serials-source').setData(shapeCollection);
    const pointCollection = featureCollection(midpoints)
    this._map.getSource('serials-midpoint-source').setData(pointCollection);
    this._clock.innerText = this.currentTime();
  }

  fetchOffset() {
    if (!this._demoing) {
      jsonFetch("/offset.json").then(this.receiveOffset.bind(this));
    }
  }

  receiveOffset(jsonData) {
    if (!this._demoing) {
      if (jsonData && jsonData.offset) {
        this._offset = jsonData.offset;
      }
    }
  }

  // TODO demo clock requires an idea of start time so that we can apply speedup
  currentTime() {
    let now = new Date().getTime();// + this._offset;
    if (this._demoing) {
      now += this._offset;
    }
    const date = new Date(now);
    return date.toLocaleTimeString();
  }

  getMissingImage(e) {
    const icon_key = e.id;
    let icon_url;
    if (/^http/.test(icon_key) || /^\//.test(icon_key)) {
      icon_url = icon_key;
    } else {
      icon_url = `/images/map/${icon_key}.png`;
    }
    if (!this._map.hasImage(icon_key)) {
      this._map.loadImage(icon_url, (error, image_data) => {
        if (!error && !this._map.hasImage(icon_key)) this._map.addImage(icon_key, image_data);
      });
    }
  }

  findFeatureAction(e) {
    this.log('findFeatureAction', e);
    const box = [
      [e.point.x - 1, e.point.y - 1],
      [e.point.x + 1, e.point.y + 1],
    ];
    const clicked_features = e.features || [];
    let clicked_feature = clicked_features[0];
    if (!clicked_feature) {
      const nearby_features = this._map.queryRenderedFeatures(box, {
        layers: ['routes', 'serials', 'serial-labels'],
      });
      clicked_feature = nearby_features[0]
    }
    this.showInfo(e, clicked_feature)
  }

  showInfo(e, feature) {
    if (e) {
      e.preventDefault();
    }
    if (feature) {
      if (feature.properties.type === 'serial') {
        const uid = feature.properties.uid;
        const serial = this.getSerial(uid)
        const serial_url = `/api/processions/${this._procession}/serials/${uid}`
        if (this._serial_cache[uid]) {
          this.displayInfo(this._serial_cache[uid]);
        } else {
          pjaxFetch(serial_url).then((html) => this.displaySerial(html, uid));
        }

      } else if (feature.properties.type === 'route') {
        const route = this.getRoute(feature.properties.uid)
        this.displayInfo(`<h3>${route.title}</h3><p>${route.description}<p>`);

      } else if (feature.properties.type === 'poi') {

      }
    }
  }

  displaySerial(html, uid) {
    if (uid) {
      this._serial_cache[uid] = html;
    }
    this.displayInfo(html);
  }

  displayInfo(html) {
    this._info.innerHTML = html;
    this._legend.classList.add('informative');
    const rect = this._info.getBoundingClientRect();
    if (rect.top > window.innerHeight) {
      window.scrollTo({
        top: window.innerHeight / 2,
        left: 0,
        behavior: 'smooth'
      });
    }
  }

  closeInfo() {
    this._legend.classList.remove('informative');
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }


  getSerial(uid) {
    return this._serials.find((s) => s.uid === uid);
  }

  getRoute(uid) {
    this.log('finding route by', uid);
    return this._routes.find((r) => r.uid === uid);
  }

  log(...messages) {
    if (this._logging && console) console.log("[TlmsMap]", ...messages);
  }
}

function lineSegmentForSerialOnRoute(serial, route, head_distance) {
  let front = (head_distance - serial.head_distance) / 3280.8398950131;  // convert attributes in feet to turf parameters in km
  let rear = front - ((serial.moving_length || 60) / 3280.8398950131);
  if (front > 0 && route.length > rear) {
    if (rear < 0) rear = 0;
    if (front > route.length) front = route.length;
    return lineSliceAlong(route.linestring, rear, front);
  }
}

function tlmsMap(el) {
  return new TlmsMap(el);
}

export default tlmsMap;
